import React from "react";
//#region types
import { ACTION_SEPARATOR } from "models/propTypes/menuPropTypes";
import { DocumentFormTypes } from "models/formTypes";
import { TranslationKeys } from "translations";
import { WintSuperkollAPIModelCustomFilters } from "wint-api-client/dist/types";
import { ReportConstants } from "utils/constants";
//#endregion
//#region components
import {
  DashboardButtonGroup,
  FilterButton,
  PageLayouts,
  ReloadEvent,
  ReportSearchInput,
  SearchContextProvider,
} from "components/common";
import { Grid } from "@mui/material";
import { useGenericDocumentService } from "serviceHooks";
import useGenericDocumentReportFilterDefinition from "./forms/useReportFilterDefinition";
import GenericDocumentsList from "./list";
import useGenericDocumentPermissions from "./hooks/useGenericDocumentPermissions";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const GenericDocumentsReport: React.FC = () => {
  const genericDocumentService = useGenericDocumentService();
  const { canViewGenericDocuments } = useGenericDocumentPermissions();
  const {
    filterFormFields: reportFilterDefinition,
    filterQueryStateHandler,
    apiToReportFilterFormatter,
  } = useGenericDocumentReportFilterDefinition();
  const title = LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Document.GenericDocuments);

  return (
    <ReloadEvent
      uniqueKey={ReportConstants.ReportKeys.GenericDocuments}
      render={(reloadKey, reload) => (
        <SearchContextProvider>
          <PageLayouts.DashboardLayout<DocumentFormTypes.GenericDocumentFilter>
            entityKey={0}
            hasPermissions={canViewGenericDocuments}
            title={title}
            topRightButtons={
              <DashboardButtonGroup
                buttons={[
                  <ReportSearchInput
                    placeholder={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Document.SearchFiles)}
                  />,
                  ACTION_SEPARATOR,
                  <FilterButton />,
                ]}
              />
            }
            filterFields={reportFilterDefinition}
            filterQueryStateHandler={filterQueryStateHandler}
            apiToReportFilterFormatter={apiToReportFilterFormatter}
            reportToAPIFilterFormatter={genericDocumentService.reportToAPIFilter}
            filterCategory={WintSuperkollAPIModelCustomFilters.FilterCategory.GenericDocument}
          >
            <Grid container item>
              <GenericDocumentsList reloadKey={reloadKey} />
            </Grid>
          </PageLayouts.DashboardLayout>
        </SearchContextProvider>
      )}
    />
  );
};

export default GenericDocumentsReport;
